import React, { FunctionComponent } from "react";
import { Label } from "src/ui";
import "./TableWidget.scss";

export interface ITableWidgetProps {
    items: any[];
    variables?: { [key: string]: string };
}
    const TableWidget: FunctionComponent<ITableWidgetProps> = (props: ITableWidgetProps) => { 

    const data = Array.isArray(props.items) ? (props.items.length > 0 ? props.items[0] : null) : props.items;

    const leftHeaderLabel = props.variables?.leftHeaderLabel || "ID";
    const rightHeaderLabel = props.variables?.rightHeaderLabel || "Sum";
    
    if (!data || !data.userData || !data.headers || !Array.isArray(data.headers)) {
        return (
            <div className="TableWidget">
                <Label size="body-2" color="mid-grey">No data available</Label>
            </div>
        );
    }

    const { userData, headers } = data;
    return (
        <div className="TableWidget">
            <div className="table-container">
                <table
                    className="table"
                    style={{                        
                        ['--table-columns' as any]: 2 + (headers?.length || 0) // 1 for id, headers.length for keys, 1 for sum
                    }}
                >
                <thead>
                    <tr>
                        <th className="header-cell id-column">
                            <Label size="body-2" weight="medium" color="dark-grey">{leftHeaderLabel}</Label>
                        </th>
                        {headers?.map((header: any, index: number) => (
                            <th key={index} className="header-cell key-column">
                                <Label size="body-2" weight="medium" color="dark-grey">
                                    {header.headerKey}
                                </Label>
                            </th>
                        ))}
                        <th className="header-cell sum-column">
                            <Label size="body-2" weight="medium" color="dark-grey">{rightHeaderLabel}</Label>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {userData?.map((user: any, userIndex: number) => {                     
                        const valuesMap = user.items.reduce((acc: any, item: any) => {
                            acc[item.key] = item.value;
                            return acc;
                        }, {});

                        return (
                            <tr key={user.id || userIndex} className="data-row">
                                <td className="data-cell id-column">
                                    <Label size="body-2" weight="normal" color="dark-grey">
                                        {user.id}
                                    </Label>
                                </td>
                                {headers.map((header: any, headerIndex: number) => (
                                    <td key={headerIndex} className="data-cell key-column">
                                        <Label size="body-2" weight="normal" color="mid-grey">
                                            {valuesMap[header.headerKey] || 0}
                                        </Label>
                                    </td>
                                ))}
                                <td className="data-cell sum-column">
                                    <Label size="body-2" weight="medium" color="dark-grey">
                                        {user.sum}
                                    </Label>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableWidget;
